import axios from 'axios'
import { call, put, takeLatest } from 'redux-saga/effects'
import { fetchArticlesAPI } from './articles'

export const FETCH_STATICPAGE = 'api/FETCH_STATICPAGE'
export const FETCH_STATICPAGE_SUCCESS = 'api/FETCH_STATICPAGE_SUCCESS'
export const FETCH_STATICPAGE_ERROR = 'api/FETCH_STATICPAGE_ERROR'

const SERVER_URL = typeof window !== 'undefined' ? '' : 'http://localhost:' + process.env.PORT

const fetchStaticPageAPI = (pageName) => {
  return axios.get(SERVER_URL + '/data/static/' + pageName)
    .then(response => response.data)
    .catch(err => {
      // console.error(err)
      throw err
    })
}

function * fetchStaticPageSaga ({ pageName }) {
  try {
    const res = yield call(fetchStaticPageAPI, pageName)
    let latestArticles = []
    try {
      latestArticles = yield call(fetchArticlesAPI, 'all-content-feed', 0, 9)
    } catch (e) {
      console.log('Unable to fetch latestArticles')
    }
    yield put({ type: FETCH_STATICPAGE_SUCCESS, payload: res, latestArticles: latestArticles.contents })
  } catch (e) {
    yield put({ type: FETCH_STATICPAGE_ERROR, payload: e.message })
  }
}

export function * watchFetchStaticPage () {
  yield takeLatest(FETCH_STATICPAGE, fetchStaticPageSaga)
}

// Saga actions
export const fetchStaticPage = (pageName) => ({ type: FETCH_STATICPAGE, isFetching: true, hasFetched: false, pageName })

export const initialState = {
  lastFetch: 0,
  didInvalidate: false,
  isFetching: false,
  hasFetched: false,
  hasError: false,
  canonical: null,
  error: null,
  latestArticles: null,
  pageName: null,
  staticPage: null // do not mutate these
}

export const Reducer = (state = initialState, { type, payload, pageName, latestArticles, meta }) => {
  switch (type) {
    case FETCH_STATICPAGE:
      return Object.assign({}, state, {
        pageName, // which page staticPage belongs to
        didInvalidate: false,
        isFetching: true,
        hasFetched: false,
        hasError: false,
        canonical: null,
        error: null
      })
    case FETCH_STATICPAGE_ERROR:
      return Object.assign({}, state, {
        hasError: true,
        error: payload,
        hasFetched: true,
        isFetching: false,
        didInvalidate: false,
        canonical: null
      })
    case FETCH_STATICPAGE_SUCCESS:
      return Object.assign({}, state, {
        lastFetch: new Date(),
        hasFetched: true,
        isFetching: false,
        didInvalidate: false,
        staticPage: payload,
        latestArticles,
        hasError: false,
        canonical: null,
        error: null
      })
    default:
      return state
  }
}
